import React from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from "@material-ui/core/styles";

import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDateTimePicker
} from '@material-ui/pickers';


const useStyles = makeStyles(theme => ({
    dialogTitle: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    dialogActions: {
        justifyContent: 'center'
    },
    dialogButton: {
        minWidth: 170,
        maxWidth: '100%'
    },
    cancelButton: {
        minWidth: 100,
    },
    form: {
        display: 'flex',
        maxWidth: 750,
        marginTop: 0,
        marginBottom: 30,
    },
}));


const CoupleAddDialog = props => {
    const {
        open,
        handleClose,
        scroll,
        handleSave
    } = props;

    const classes = useStyles();

    const now = new Date();

    const clearedForm = {
        bride_first_name: '',
        bride_last_name: '',
        bride_email: '',
        groom_first_name: '',
        groom_last_name: '',
        groom_email: '',
        couple_cell: '',
        venue: '',
        wedding_date: new Date(now.getFullYear(), now.getMonth(), now.getDate() + 7, 12, 0),
        couple_type: 'Lead',
    };
    const statuses = ['Lead', 'Follow-Up', 'Pending', 'Booked', 'Complete', 'Cancelled'];

    const [showProgress, setShowProgress] = React.useState(false);

    /* form state */
    const [state, setState] = React.useState(clearedForm);
    const updateState = (value, name) => {
        const data = {
            ...state,
            [name]: value,
        };
        setState(data);
    }
    const handleChange = name => event => {
        let value;
        if (name == 'wedding_date') {
            value = event;
        } else {
            value = event.target.value;
        }
        updateState(value, name);
    }

    const submitForm = event => {
        event.preventDefault();

        const formData = {
            ...state,
            _token: window._token
        };
        new Promise((resolve, reject) => {
            const url = '/api/couples';
            setShowProgress(true);
            fetch(url, {
                method: 'POST',
                body: JSON.stringify(formData),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    resolve();
                    if (result.errors) {
                        alert(result.errors);
                        return;
                    }
                    setTimeout(() => {
                        setState(clearedForm);
                        handleSave();
                        handleClose();
                    }, 30);
                })
                .catch(reason => {
                    alert('Please try again');
                })
                .finally(() => {
                    setShowProgress(false);
                })
        });
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth='xl'
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>Add Couple</DialogTitle>
            <DialogContent dividers={scroll === 'paper'}>
                <form className={classes.form} onSubmit={submitForm} id="couple-add-form">
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <TextField
                                autoFocus
                                fullWidth
                                id="bride-first-name"
                                margin="normal"
                                onChange={handleChange('bride_first_name')}
                                label="Bride First Name"
                                value={state.bride_first_name || ''}
                                required
                            />
                            <TextField
                                fullWidth
                                id="bride-last-name"
                                margin="normal"
                                onChange={handleChange('bride_last_name')}
                                label="Bride Last Name"
                                value={state.bride_last_name || ''}
                                required
                            />
                            <TextField
                                fullWidth
                                id="bride-email"
                                margin="normal"
                                onChange={handleChange('bride_email')}
                                label="Bride Email"
                                type="email"
                                value={state.bride_email || ''}
                                required
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                id="groom-first-name"
                                margin="normal"
                                onChange={handleChange('groom_first_name')}
                                label="Groom First Name"
                                value={state.groom_first_name || ''}
                                required
                            />
                            <TextField
                                fullWidth
                                id="groom-last-name"
                                margin="normal"
                                onChange={handleChange('groom_last_name')}
                                label="Groom Last Name"
                                value={state.groom_last_name || ''}
                                required
                            />
                            <TextField
                                fullWidth
                                id="groom-email"
                                margin="normal"
                                onChange={handleChange('groom_email')}
                                label="Groom Email"
                                type="email"
                                value={state.groom_email || ''}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} style={{paddingTop: 0}}>
                            <TextField
                                fullWidth
                                id="bride-cell"
                                margin="normal"
                                onChange={handleChange('couple_cell')}
                                label="Bride Cell"
                                value={state.couple_cell || ''}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} style={{paddingTop: 0}}>
                            <TextField
                                fullWidth
                                id="wedding-venue"
                                margin="normal"
                                onChange={handleChange('venue')}
                                label="Wedding Venue"
                                value={state.venue || ''}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} style={{paddingTop: 5}}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDateTimePicker
                                    margin="normal"
                                    id="wedding-date"
                                    label="Wedding Date"
                                    fullWidth
                                    value={state.wedding_date}
                                    onChange={handleChange('wedding_date')}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    required
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12} sm={6} style={{paddingTop: 5}}>
                            <TextField
                                select
                                fullWidth
                                margin="normal"
                                onChange={handleChange('couple_type')}
                                label="Stage"
                                value={state.couple_type}
                                SelectProps={{
                                    autoWidth: true
                                }}
                                required
                            >
                                {statuses.map((option, k) => (
                                    <MenuItem key={k} value={option}>
                                        {option}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    </Grid>
                </form>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button onClick={handleClose} variant="outlined" className={[classes.dialogButton, classes.cancelButton].join(', ')}>
                    Cancel
                </Button>
                <Box component="span">
                    <Button
                        disabled={!state.bride_first_name || !state.bride_last_name || !state.bride_email || !state.groom_first_name || !state.groom_last_name || !state.groom_email || !state.venue || !state.couple_cell || showProgress}
                        variant="contained"
                        color="primary"
                        type="submit"
                        form="couple-add-form"
                        className={classes.dialogButton}
                        endIcon={showProgress ? <CircularProgress size={20} /> : null}
                    >
                        Add Couple
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
}

export default CoupleAddDialog;
